module.exports = __webpack_public_path__ + "img/zhiyebaike.32927a1d.svg";